/* Catalog cards use the product JSON rendered by Shopify for this request. */
(() => {
  'use strict';
  const config = window.BasicShopify || {};
  const products = config.products || {};
  const language = document.documentElement.lang.slice(0, 2);
  const copy = ({fr:{from:'Dès',soldOut:'Épuisé'},de:{from:'Ab',soldOut:'Ausverkauft'},en:{from:'From',soldOut:'Sold out'}})[language] || {from:'Dès',soldOut:'Épuisé'};
  const types = [
    {className:'catalogue-card',price:'.catalogue-card-meta > strong',media:'.catalogue-card-media',badge:'.catalogue-card-status',badgeClass:'catalogue-card-status',soldClass:'is-soldout'},
    {className:'family-product',price:'.family-product-meta > strong',media:'.family-product-media',badge:'.family-soldout',badgeClass:'family-soldout',soldClass:'family-product--soldout'},
    {className:'home-product-card',price:'.home-product-meta > span:last-child',media:'.home-product-media',badge:'.basic-product-status',badgeClass:'basic-product-status',soldClass:'is-soldout'},
    {className:'catalog-related-card',price:':scope > span:last-of-type',media:null,badge:'.basic-product-status',badgeClass:'basic-product-status',soldClass:'is-soldout'}
  ];
  const selector = types.map(type => `a.${type.className}`).join(', ');
  const priceNumber = value => typeof value === 'number' && Number.isFinite(value) && Number.isInteger(value) && value >= 0 ? value : null;
  function productFor(card) {
    const href = card.getAttribute('href');
    if (!href) return null;
    try {
      let url = new URL(href, document.baseURI);
      if (url.origin !== location.origin) return null;
      const page = url.pathname.split('/').pop();
      const mapped = config.productRoutes?.[page];
      if (mapped) url = new URL(mapped, location.origin);
      const handle = /\/products\/([a-z0-9-]+)\/?$/.exec(url.pathname)?.[1];
      return handle ? products[handle] || null : null;
    } catch {return null;}
  }
  function money(value) {
    const currency = config.currency || 'CHF';
    return currency === 'CHF' ? `CHF ${(value / 100).toFixed(2).replace('.00', '.–')}`
      : new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency}).format(value / 100);
  }
  function syncCard(card) {
    if (window.BasicCampaignRetirement?.isEnded() && window.BasicCampaignRetirement.campaignUrl(card.href)) {
      (card.closest('.catalogue-item, .catalogue-card-wrap') || card).remove(); return null;
    }
    const type = types.find(type => card.classList.contains(type.className));
    if (!type) return null;
    const product = productFor(card);
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
    const variantPrices = product.variants.map(variant => priceNumber(variant.price)).filter(value => value !== null);
    const minimum = priceNumber(product.price_min) ?? priceNumber(product.price) ?? (variantPrices.length === product.variants.length ? Math.min(...variantPrices) : null);
    const price = card.querySelector(type.price);
    if (price && minimum !== null) {
      const from = product.price_varies === true || /^(?:Dès|Ab|From)\s/i.test(price.textContent.trim());
      const next = `${from ? `${copy.from} ` : ''}${money(minimum)}`;
      if (price.textContent !== next) price.textContent = next;
    }
    // Explicit product/variant booleans are required. Missing JSON or unknown
    // availability never turns a stale sold-out badge into an available item.
    const available = product.available === false ? false
      : product.variants.some(variant => variant.available === true) ? true
      : product.variants.every(variant => variant.available === false) ? false
      : typeof product.available === 'boolean' ? product.available : null;
    if (available !== null) {
      card.classList.toggle(type.soldClass, !available);
      card.dataset.shopifyAvailable = String(available);
      const badge = card.querySelector(type.badge);
      if (available) badge?.remove();
      else if (badge) {if (badge.textContent !== copy.soldOut) badge.textContent = copy.soldOut;}
      else {
        const status = document.createElement(type.media ? 'span' : 'small');
        status.className = type.badgeClass; status.textContent = copy.soldOut;
        (type.media && card.querySelector(type.media) || card).append(status);
      }
    }
    return {available,minimum};
  }
  function sync(root = document) {
    if (root.nodeType === 1 && root.matches(selector)) syncCard(root);
    root.querySelectorAll?.(selector).forEach(syncCard);
  }
  window.BasicShopifyCatalog = {syncCard,sync};
  sync();
  // Search imports cards asynchronously. Only direct insertions into that one
  // grid are observed; changing a price or badge cannot retrigger this observer.
  const grid = document.getElementById('search-results-grid');
  if (grid && typeof MutationObserver !== 'undefined') {
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {if (node.nodeType === 1) sync(node);})))
      .observe(grid, {childList:true});
  }
})();
